export default "__VITE_ASSET__Bqra0MSF__"